package com.heelion.farmafreelance.ui

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.*
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.filled.Star
import androidx.compose.material3.*
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Brush
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.platform.LocalUriHandler
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import com.heelion.farmafreelance.ABBONAMENTI_ATTIVI
import com.heelion.farmafreelance.PAYMENT_APP_ID
import com.heelion.farmafreelance.PAYMENT_HUB_URL

@Composable
fun PremiumGuard(
    viewModel: AuthViewModel,
    content: @Composable () -> Unit
) {
    if (viewModel.accessoCompleto) {
        content()
    } else {
        Card(
            modifier = Modifier
                .fillMaxWidth()
                .padding(16.dp),
            shape = RoundedCornerShape(16.dp),
            elevation = CardDefaults.cardElevation(defaultElevation = 4.dp)
        ) {
            Box(
                modifier = Modifier
                    .background(
                        Brush.verticalGradient(
                            colors = listOf(
                                Color(0xFFFFD700).copy(alpha = 0.1f),
                                Color(0xFFFFD700).copy(alpha = 0.05f)
                            )
                        )
                    )
                    .padding(24.dp)
            ) {
                Column(
                    horizontalAlignment = Alignment.CenterHorizontally,
                    modifier = Modifier.fillMaxWidth()
                ) {
                    Icon(
                        Icons.Default.Star,
                        contentDescription = null,
                        tint = Color(0xFFFFD700),
                        modifier = Modifier.size(48.dp)
                    )
                    
                    Spacer(modifier = Modifier.height(16.dp))
                    
                    Text(
                        "Funzionalità Premium",
                        style = MaterialTheme.typography.titleLarge,
                        fontWeight = FontWeight.Bold
                    )
                    
                    Spacer(modifier = Modifier.height(8.dp))
                    
                    Text(
                        "Sblocca questa funzione e molto altro con un abbonamento FarmaFreelance Premium.",
                        style = MaterialTheme.typography.bodyMedium,
                        textAlign = TextAlign.Center,
                        color = Color.Gray
                    )
                    
                    Spacer(modifier = Modifier.height(24.dp))
                    
                    val uriHandler = LocalUriHandler.current
                    val role = if (viewModel.currentUserFarmacia != null) "FARMACIA" else viewModel.currentUserRole?.name ?: "FARMACISTA"

                    Button(
                        onClick = {
                            // Punta alla root dell'Hub passando il ruolo e l'ID UNIVCO (es. FARMACISTA_1)
                            val userId = viewModel.getUnivocoUtenteId() ?: ""
                            uriHandler.openUri("$PAYMENT_HUB_URL?app=$PAYMENT_APP_ID&role=$role&userId=$userId")
                        },
                        colors = ButtonDefaults.buttonColors(containerColor = Color(0xFFFFD700), contentColor = Color.Black),
                        shape = RoundedCornerShape(8.dp),
                        modifier = Modifier.fillMaxWidth()
                    ) {
                        Text("Attiva Premium", fontWeight = FontWeight.Bold)
                    }

                    Spacer(modifier = Modifier.height(12.dp))
                    
                    if (viewModel.isLoading) {
                        CircularProgressIndicator(color = Color(0xFFFFD700), modifier = Modifier.size(24.dp))
                    } else {
                        TextButton(
                            onClick = { 
                                viewModel.fetchSubscriptionStatus() 
                            },
                            modifier = Modifier.fillMaxWidth()
                        ) {
                            Text("Ho già pagato, verifica", color = Color(0xFFFFD700))
                        }
                    }

                    viewModel.successMessage?.let { msg ->
                        Text(msg, color = Color(0xFF4CAF50), style = MaterialTheme.typography.labelSmall, modifier = Modifier.padding(top = 8.dp))
                    }
                    viewModel.actionErrorMessage?.let { err ->
                        Text(err, color = Color.Red, style = MaterialTheme.typography.labelSmall, modifier = Modifier.padding(top = 8.dp))
                    }
                }
            }
        }
    }
}

@Composable
fun TrialBanner(daysRemaining: Int) {
    if (!ABBONAMENTI_ATTIVI) return
    Surface(
        color = MaterialTheme.colorScheme.primaryContainer,
        contentColor = MaterialTheme.colorScheme.onPrimaryContainer
    ) {
        Row(
            modifier = Modifier
                .fillMaxWidth()
                .padding(vertical = 4.dp, horizontal = 16.dp),
            horizontalArrangement = Arrangement.Center,
            verticalAlignment = Alignment.CenterVertically
        ) {
            Icon(Icons.Default.Star, contentDescription = null, modifier = Modifier.size(16.dp))
            Spacer(modifier = Modifier.width(8.dp))
            Text(
                "Versione TRIAL: Mancano $daysRemaining giorni alla scadenza",
                style = MaterialTheme.typography.labelSmall,
                fontWeight = FontWeight.Bold
            )
        }
    }
}
